import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const paper = css`
  padding-block: ${spacing(0.5)};
`
export const header = css`
  block-size: ${spacing(7)};
`
